import React from "react";
import { FaNotesMedical } from "react-icons/fa";
import useSystemVariable from "./shared/useSystemVariable";
import SystemVariablePage from "./shared/SystemVariablePage";
import {
  useListDiagnosisCategoriesMutation, useCreateDiagnosisCategoryMutation,
  useUpdateDiagnosisCategoryMutation, useDeleteDiagnosisCategoryMutation,
} from "../../store/systemVariablesApi";

export default function DiagnosisCategories() {
  const vm = useSystemVariable({
    listMutation: useListDiagnosisCategoriesMutation(),
    createMutation: useCreateDiagnosisCategoryMutation(),
    updateMutation: useUpdateDiagnosisCategoryMutation(),
    deleteMutation: useDeleteDiagnosisCategoryMutation(),
    itemsKey: "categories",
    idKey: "categoryId",
    defaultForm: { name: "" },
    itemToForm: (it) => ({ name: it?.name || "" }),
    formToPayload: (form) => ({ name: form.name }),
    entityLabel: "Tanı Kategorisi",
  });

  return (
    <SystemVariablePage
      icon={<FaNotesMedical size={22} />}
      title="Tanı Kategorileri"
      subtitle="Tanıları gruplamak için kullanılan kategori listesi"
      entityLabel="Kategori"
      vm={vm}
      tableColumns={[{ key: "name", label: "Kategori Adı", bold: true }]}
      formFields={[{ key: "name", label: "Kategori Adı", required: true }]}
    />
  );
}
